import { createAction, props } from "@ngrx/store";
import { Questionnaire, Reponse } from "../../models/open/questionnaire.model";

export const ADD_QUESTIONNAIRE="[ADD_QUESTIONNAIRE] Add Questionnaire";
export const UPDATE_QUESTIONNAIRE="[UPDATE_QUESTIONNAIRE] Update Questionnaire";
export const UPDATE_QUESTIONNAIRE_RADIO="[UPDATE_QUESTIONNAIRE_RADIO] Update Questionnaire Radio";
export const UPDATED_QUESTIONNAIRE_RADIO="[UPDATED_QUESTIONNAIRE_RADIO] Updated Questionnaire Radio";
export const UPDATE_QUESTIONNAIRE_SLIDER="[UPDATE_QUESTIONNAIRE_SLIDER] Update Questionnaire Slider";
export const UPDATED_QUESTIONNAIRE_SLIDER="[UPDATED_QUESTIONNAIRE_SLIDER] Updated Questionnaire Slider";
export const UPDATE_QUESTIONNAIRE_DATE="[UPDATE_QUESTIONNAIRE_DATE] Update Questionnaire Date";
export const UPDATE_QUESTIONNAIRE_INPUT="[UPDATE_QUESTIONNAIRE_INPUT] Update Questionnaire Input";
export const UPDATED_QUESTIONNAIRE_INPUT="[UPDATED_QUESTIONNAIRE_INPUT] Updated Questionnaire Input";
export const UPDATE_QUESTIONNAIRE_CHECK="[UPDATE_QUESTIONNAIRE_CHECK] Update Questionnaire Check";
export const UPDATED_QUESTIONNAIRE_CHECK="[UPDATED_QUESTIONNAIRE_CHECK] Updated Questionnaire Check";
export const UPDATE_QUESTIONNAIRE_LISTE="[UPDATE_QUESTIONNAIRE_LISTE] Update Questionnaire Liste";
export const UPDATED_QUESTIONNAIRE_LISTE="[UPDATED_QUESTIONNAIRE_LISTE] Updated Questionnaire Liste";

export const addQuestionnaire = createAction(
	ADD_QUESTIONNAIRE,
	(questionnaire: Questionnaire) => {
		return questionnaire;
	}
);

// export const updateQuestionnaire = createAction(
// 	UPDATE_QUESTIONNAIRE,
// 	(questionnaire: Questionnaire, question_id: number, reponse: Reponse) => {
// 		return { questionnaire: questionnaire, qid: question_id, reponse: reponse };
// 	}
// );
export const updateQuestionnaire = createAction(
	UPDATE_QUESTIONNAIRE,
	props<{ qid: number,reponse_id:number, reponse: string, hash: string,checked:boolean }>()
);
export const updateQuestionnaireRadio = createAction(
	UPDATE_QUESTIONNAIRE_RADIO,
	props<{ qid: number,reponse_id:number, reponse: string, hash: string,checked:boolean }>()
);
export const updatedQuestionnaireRadio = createAction(
	UPDATED_QUESTIONNAIRE_RADIO
);

export const updateQuestionnaireSlider = createAction(
	UPDATE_QUESTIONNAIRE_SLIDER,
	props<{ qid: number,reponse_id:number, reponse: string, hash: string,checked:boolean }>()
);
export const updatedQuestionnaireSlider = createAction(
	UPDATED_QUESTIONNAIRE_SLIDER
);

export const updateQuestionnaireDate = createAction(
	UPDATE_QUESTIONNAIRE_DATE,
	props<{ qid: number,reponse_id:number, reponse: string, hash: string,checked:boolean }>()
);
export const updateQuestionnaireInput = createAction(
	UPDATE_QUESTIONNAIRE_INPUT,
	props<{ qid: number,reponse_id:number, reponse: string, hash: string,checked:boolean }>()
);
export const updatedQuestionnaireInput = createAction(
	UPDATED_QUESTIONNAIRE_INPUT,
);
export const updateQuestionnaireCheck = createAction(
	UPDATE_QUESTIONNAIRE_CHECK,
	props<{ qid: number,reponse_id:number, reponse: string, hash: string ,checked:boolean}>()
);
export const updatedQuestionnaireCheck = createAction(
	UPDATED_QUESTIONNAIRE_CHECK
);


